"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "Keyboard___StyledSvg",
  componentId: "sc-4u2otz-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

function Keyboard(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M65.875 118h348.75c19.234 0 34.875 15.641 34.875 34.875V327.25c0 19.234-15.641 34.875-34.875 34.875H65.875C46.641 362.125 31 346.484 31 327.25V152.875C31 133.641 46.641 118 65.875 118zm0 209.25h348.767l-.017-174.375H65.875V327.25zm87.188-139.5c0 9.643-7.813 17.438-17.438 17.438-9.626 0-17.438-7.795-17.438-17.438 0-9.625 7.813-17.438 17.438-17.438s17.438 7.813 17.438 17.438zm52.312 0c0 9.643-7.812 17.438-17.438 17.438-9.625 0-17.437-7.795-17.437-17.438 0-9.625 7.812-17.438 17.438-17.438 9.625 0 17.437 7.813 17.437 17.438zm52.313 0c0 9.643-7.813 17.438-17.438 17.438s-17.438-7.795-17.438-17.438c0-9.625 7.813-17.438 17.438-17.438s17.438 7.813 17.438 17.438zm52.312 0c0 9.643-7.812 17.438-17.438 17.438-9.625 0-17.437-7.795-17.437-17.438 0-9.625 7.812-17.438 17.438-17.438 9.625 0 17.437 7.813 17.437 17.438zm52.313 0c0 9.643-7.813 17.438-17.438 17.438s-17.438-7.795-17.438-17.438c0-9.625 7.813-17.438 17.438-17.438s17.438 7.813 17.438 17.438zm-209.25 52.313c0 9.642-7.813 17.437-17.438 17.437-9.626 0-17.438-7.795-17.438-17.438 0-9.625 7.813-17.437 17.438-17.437s17.438 7.812 17.438 17.438zm52.312 0c0 9.642-7.812 17.437-17.438 17.437-9.625 0-17.437-7.795-17.437-17.438 0-9.625 7.812-17.437 17.438-17.437 9.625 0 17.437 7.812 17.437 17.438zm52.313 0c0 9.642-7.813 17.437-17.438 17.437s-17.438-7.795-17.438-17.438c0-9.625 7.813-17.437 17.438-17.437s17.438 7.812 17.438 17.438zm52.312 0c0 9.642-7.812 17.437-17.438 17.437-9.625 0-17.437-7.795-17.437-17.438 0-9.625 7.812-17.437 17.438-17.437 9.625 0 17.437 7.812 17.437 17.438zm52.313 0c0 9.642-7.813 17.437-17.438 17.437s-17.438-7.795-17.438-17.438c0-9.625 7.813-17.437 17.438-17.437s17.438 7.812 17.438 17.438zM310 309.813H170.5v-34.875H310v34.875z"
  }));
}

var _default = Keyboard;
exports["default"] = _default;